__turbopack_context__.v({
  "card": "CategoriesV2-module__BCZt2W__card",
  "catCount": "CategoriesV2-module__BCZt2W__catCount",
  "catImage": "CategoriesV2-module__BCZt2W__catImage",
  "container": "CategoriesV2-module__BCZt2W__container",
  "grid": "CategoriesV2-module__BCZt2W__grid",
  "icon": "CategoriesV2-module__BCZt2W__icon",
  "imageWrapper": "CategoriesV2-module__BCZt2W__imageWrapper",
  "name": "CategoriesV2-module__BCZt2W__name",
  "section": "CategoriesV2-module__BCZt2W__section",
  "title": "CategoriesV2-module__BCZt2W__title",
});
